import { ComponentPropsWithRef } from 'react';
import { getS3Url, MediaOpts } from './get-s3-url';

export type S3ImgProps = {
  path?: string;
} & MediaOpts &
  Omit<ComponentPropsWithRef<'img'>, 'src'>;
export const S3Img = function S3Img({
  ref,
  path,
  w,
  h,
  rs,
  ...rest
}: S3ImgProps & {
  ref?: React.Ref<HTMLImageElement>;
}) {
  const url = getS3Url(path, { w, h, rs });

  return <img ref={ref} src={url?.toString()} {...rest} />;
};
